import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppMaterialModule } from 'src/app/app-material/app-material.module';
import { GetPathDialogComponent } from './get-path-dialog.component';



@NgModule({
  declarations: [GetPathDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    AppMaterialModule
  ],
  entryComponents: [GetPathDialogComponent]
})
export class GetPathDialogModule { }
